import { render, staticRenderFns } from "./InstitutionContainersHistory.vue?vue&type=template&id=760c1c8e&"
import script from "./InstitutionContainersHistory.vue?vue&type=script&lang=js&"
export * from "./InstitutionContainersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports